import {ApiResponse} from "../../models";

export function handleApiError(error: any, defaultMessage?: string): Promise<ApiResponse> {
    let response: ApiResponse;
    if (typeof error === "string") {
        response = {
            errorMessage: error
        };
    } else if (error?.response?.data?.message) {
        response = {
            errorMessage: error.response.data.message
        };
    } else if (typeof error?.response?.data === "string" && !error.response.data.trim().startsWith("<")) {
        response = {
            errorMessage: error.response.data
        };
    } else if (error?.response?.data) {
        // Non-string body (a JSON object without `.message`) or an HTML gateway
        // page — don't surface "[object Object]" or a raw HTML blob; fall back to
        // a human-readable string (F67).
        response = {
            errorMessage: defaultMessage || "Something went wrong while making a request to the server. Please check back later."
        };
    } else {
        response = {
            errorMessage: defaultMessage || "Something went wrong while making a request to the server. Please check back later."
        };
    }

    if (error?.response?.data?.errors){
        response = {...response, errors: error?.response?.data?.errors};
    }

    if (error?.response?.status) {
        response.status = error.response.status;
    }

    return Promise.reject(response);
}
